import {Home} from 'src/modules'

export const HomePage = () => {
  return <Home />
}
